import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import Box from "ds/components/Box";

import { FileTreeNode } from "../../../fileTreeHelpers";
import SpaceliftVcsRepoFileRowActions from "../../../components/FileRowActions";
import useFilesNavigation from "../useFilesNavigation";

const RowActionsCell = ({ item, ...cellProps }: TableSimpleCellProps<FileTreeNode>) => {
  const { folderPathSegments, setCurrentPath } = useFilesNavigation();

  const isFolder = item.type === "folder";
  const isParent = item.type === "parent";

  if (isParent) {
    return (
      <TableSimpleCell {...cellProps}>
        <Box direction="row" padding="0 0 0 medium">
          <TableCellEmpty />
        </Box>
      </TableSimpleCell>
    );
  }

  if (isFolder) {
    return (
      <TableSimpleCell {...cellProps}>
        <DropdownMenuEllipsis tooltip="Row actions">
          <DropdownMenuItem onAction={() => setCurrentPath(item.path.split("/"))}>
            View
          </DropdownMenuItem>
        </DropdownMenuEllipsis>
      </TableSimpleCell>
    );
  }

  return (
    <TableSimpleCell {...cellProps}>
      <SpaceliftVcsRepoFileRowActions
        filePath={item.path}
        onDeleteSuccess={() => {
          if (folderPathSegments.length > 0 && item.siblingCount === 1) {
            setCurrentPath([]);
          }
        }}
      />
    </TableSimpleCell>
  );
};

export default RowActionsCell;
